import React, { FunctionComponent } from 'react';
import { Switch } from 'components/UI/V3/Forms/Switch';
import { DateRangeSection } from '../DateRangeSection/DateRangeSection';
import { ValidationErrors } from '../../types';
import styles from './SelectDatesSection.module.scss';

interface SelectDatesSectionProps {
    enabled: boolean;
    startDate: Date | null;
    endDate: Date | null;
    onChange: (data: { enabled: boolean; startDate: Date | null; endDate: Date | null }) => void;
    errors?: ValidationErrors;
}

export const SelectDatesSection: FunctionComponent<SelectDatesSectionProps> = ({
    enabled,
    startDate,
    endDate,
    onChange,
    errors
}) => {
    const handleToggle = (checked: boolean) => {
        onChange({
            enabled: checked,
            startDate: checked ? startDate : null,
            endDate: checked ? endDate : null
        });
    };

    const handleDateChange = (dates: { startDate: Date | null; endDate: Date | null }) => {
        onChange({
            enabled,
            ...dates
        });
    };

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <h3 className={styles.title}>Select Dates</h3>
                <Switch
                    checked={enabled}
                    onChange={handleToggle}
                />
            </div>

            <p className={styles.description}>Set the applicable days for this rate rule.</p>

            {enabled && (
                <div className={styles.dateRangeWrapper}>
                    <DateRangeSection
                        startDate={startDate}
                        endDate={endDate}
                        onChange={handleDateChange}
                        errors={errors}
                    />
                </div>
            )}
        </div>
    );
};
